import {AxiosInstance} from 'axios';
import {BaseHttpRequest, CancelablePromise, OpenAPIConfig} from '@di-shared/api/di/__generated';
import {request as __request} from '@di-shared/api/di/__generated/core/request';
import {ApiRequestOptions} from '@di-shared/api/di/__generated/core/ApiRequestOptions';
import {diAxios} from '@di-shared/api/di/axiosInstance';

export class DiAxiosHttpRequest extends BaseHttpRequest {
  axiosInstance: AxiosInstance;

  constructor(config: OpenAPIConfig) {
    super(config);
    this.axiosInstance = diAxios;
  }

  /**
   * Request method
   * @param options The request options from the service
   * @returns CancelablePromise<T>
   * @throws ApiError
   */
  public override request<T>(options: ApiRequestOptions): CancelablePromise<T> {
    return __request(this.config, options, this.axiosInstance);
  }
}
